import React from 'react';
import ReactDOM from 'react-dom';
import mixin from 'react-mixin';

const RealizeButton = window.Button;
const RealizeTooltipMixin = window.TooltipMixin;
let debounce;

@mixin.decorate(RealizeTooltipMixin)
export default class Button extends RealizeButton {

	parseButtonProps(buttonProps) {
		return Object.assign({}, buttonProps, this.tooltipAttributes(), {
			id: this.props.id,
			ref: 'button',
			className: this.getButtonClassName(),
			href: this.getButtonHref(),
			onClick: this.handleTooltipedButtonClick.bind(this),
			onKeyDown: this.handleOnKeyDown.bind(this),
			style: this.props.cssStyle,
			'data-tooltip': Realize.i18n.t(this.props.tooltipText),
			'aria-label': this.props['aria-label'],
			role: this.props['role'],
			tabIndex: 0
		});
	}

	handleOnKeyDown(e) {		
		const element = e.currentTarget;

		if(e.key === 'Enter' && element.tagName !== "BUTTON") {			
			if(debounce) {
				clearTimeout(debounce);
			}
			
			debounce = setTimeout(() => {						
            	element.click();
			}, 300);			
		}
	}

	getButtonClassName() {
		let className = this.className();
		if (this.props.disabled && this.props.element === 'a')
			className += ' disabled-button';
		if(!!this.props.tooltipText)
			className += ' tooltipped';

			className += this.getVisibility();

		return className;
	}

	getVisibility(){
		if(this.props.visibility !== null && this.props.visibility !== undefined) return " "+this.props.visibility;
		return "";
	}

	getButtonHref() {
		if (this.props.disabled && this.props.element === 'a')
			return null;
		return this.props.href;
	}

	handleTooltipedButtonClick(event) {
		$(ReactDOM.findDOMNode(this.refs.button)).trigger('mouseleave');
		if(this.props.disabled) {
			return;
		}

		let buttonOnClick = this.props.onClick;
		let buttonAction = this.props.actionUrl;

		if(typeof buttonOnClick == "function") {
			this.props.onClick(event);
		} else if(!!buttonAction) {
			let actionData = this.props.actionData;
			this.performRequest(buttonAction, actionData, (this.getMethod() || 'POST'));
		}
	}

	componentWillReceiveProps(newProps) {
		const { style } = newProps;
		if(style) {
			this.setState({
				themeClassKey: `${this.getButtonThemeClassKey()} button.${style}`,
			});
		}
	}

	render() {
		const button = super.render();
		return React.createElement(
			this.props.element,
			this.parseButtonProps(button.props),
			button.props.children
		);
	}

}
